export interface ILicenseData {
    featureName: string;
    applicationId: string;
    macId: string;
    featureGroup: string;
    featureCount: number;
    remainingfeaturecount: number;
    creationDate: string;
    expiryDate?: string;
    licenseRemainingDays?: number;
    isLifeTimeLicense?: boolean;
    hasValidLicense?: boolean;
    isLicenseApplicable?: boolean;
  }
  
  export default class LicenseData implements ILicenseData {
    featureName: string;
    applicationId: string;
    macId: string;
    featureGroup: string;
    featureCount: number;
    remainingfeaturecount: number;
    creationDate: string;
    expiryDate?: string;
    licenseRemainingDays?: number;
    isLifeTimeLicense?: boolean;
    hasValidLicense?: boolean;
    isLicenseApplicable?: boolean;
  
    constructor(
      featureName: string,
      applicationId: string,
      macId: string,
      featureGroup: string,
      featureCount: number,
      remainingfeaturecount: number,
      creationDate: string,
      expiryDate?: string,
      licenseRemainingDays?: number,
      isLifeTimeLicense?: boolean,
      hasValidLicense?: boolean,
      isLicenseApplicable?: boolean,
    ) {
      this.featureName = featureName;
      this.applicationId = applicationId;
      this.macId = macId;
      this.featureGroup = featureGroup;
      this.featureCount = featureCount;
      this.remainingfeaturecount = remainingfeaturecount;
      this.creationDate = creationDate;
      this.expiryDate = expiryDate;
      this.licenseRemainingDays = licenseRemainingDays;
      this.isLifeTimeLicense = isLifeTimeLicense;
      this.hasValidLicense = hasValidLicense;
      this.isLicenseApplicable = isLicenseApplicable;
    }
  }
  
  const defaultLicenseData = new LicenseData("", "", "", "", 0, 0, "", "", 0, false, false, false);
  export { defaultLicenseData };